import React from "react";
import Footer from "./Footer";
import logo from "../../../../vendor/Whiteswan-New-Logo-Blue.png";

const AuthenticationPage = (props) => {
  const { children } = props;
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm h-20 flex items-center px-4 lg:px-8">
        <img
          src={logo}
          alt="Whiteswan Logo"
          className="h-16 w-auto"
        />
      </header>
      
      {/* Main Content */}
      <main className="flex-1 flex justify-center items-center py-4">
        {children}
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AuthenticationPage;
